<template src="./BaseTable.html">

</template>

<script>

  import {
    singleCol, multipleCol, actionCol
  } from './customCols'
  import RenderCell from './RenderCell.vue'

  export default {
    components: {
      RenderCell
    },
    name: "fpBaseTable",
    props: {
      defaultSort: {},
      "cols": {
        type: Array,
        default: []
      },
      "dataSource": {
        type: Array,
        default: function () {
          return [];
        }
      },
      "selectType": {
        type: String,
      },
      "singleSelectTypeIcon": {
        type: String,
        default: "fa fa-edit"
      },
      "singleSelectText": {
        type: String,
        default: ""
      },
      "size": {
        type: String,
        default: "default"
      },
      "selectedArray": {
        type: Array,
        default: function () {
          return [];
        }
      },
      "keyPath": {
        default: "id"
      }
    },
    methods: {
      handleEdit(index, row) {
        this.$emit('onSingleSelect', {index, row});
      },
      handleRowDbClick(row) {
        this.$emit('onSingleSelect', {row});
      },
      handleSelectionChange(val) {
        if (this.selectType == 'multiple' || this.selectType == 'both') {
          this.dataSource.forEach(t => {
            t.__selected = false;
          })
          val.forEach(v => {
            v.__selected = true;
          })
        }
        this.$emit('onSelect', val);
      },
      handleSort(e) {
//        if (!e.prop && !e.sort) {
//          this.$refs.baseTable.sort(this.defaultSort);
//        } else {
//          this.$emit('onSort', e);
//        }
        this.$emit('onSort', e);
      },
      handleCommand(actionId, row) {
        this.$emit('onCommandSelect', {actionId, row});
      },
      getWidthByText(singleText) {
        if (singleText) {
          return 50 + singleText.length * 12;
        }
        return 50;
      },
      handleRowClick(row, event, column) {
        this.$refs.baseTable.toggleRowSelection(row);
      },
      clearSelection() {
        this.$refs.baseTable.clearSelection();
      },
      fillSelection() {
        if (this.selectType == 'multiple' || this.selectType == 'both') {
          var intersectionArray = _.intersectionBy(this.dataSource, this.selectedArray, this.keyPath);
          this.$nextTick(() => {
            intersectionArray.forEach(t => {
              this.handleRowClick(t, null, null);
            });
          })
        }
      }
    },
    computed: {
      columns() {
        var cols = [];

        if (this.selectType == 'multiple' || this.selectType == 'both') {
          cols.push(multipleCol);
        }

        if (this.selectType == 'single' || this.selectType == 'both') {
          cols.push(singleCol(this.singleSelectTypeIcon, this.singleSelectText, this.handleEdit));
        }


        var actCol = _.find(this.cols, t => t.action);
        if (actCol) {
          cols.push(actionCol(actCol.actions, this.handleCommand));
        }

        cols = cols.concat(_.filter(this.cols, t => !t.action).map(t => {
          return {
            title: t.label,
            key: t.prop,
            width: t.minWidth,
            render: t.render,
            ellipsis: true,
            sortable: t.sortable ? 'custom' : false,
            align: t.align
          }
        }));

        return cols;
      },
      singleType: function () {
        if (this.selectType == "single" || this.selectType == "both") {
          return true;// !(_.some(this.cols, {action: true}));
        }
        return false;
      },
      multipleType: function () {
        if (this.selectType == "multiple" || this.selectType == "both") {
          return true;//!(_.some(this.cols, {action: true}));
        }

        return false;
      },
      actionType: function () {
        return _.some(this.cols, {action: true});
      },
      realCols: function () {
        return _.filter(this.cols, t => !t.action).map(t => {
          if (!t.minWidth) {
            t.showOverflowTooltip = true;
          }
          if(t.sortable){
              t.sortOrders=['ascending', 'descending'];
          }
          return t;
        });
      },
      actionCol: function () {
        return _.find(this.cols, t => t.action);
      }
    },
    watch: {
      dataSource(n, o) {
        if (n != o) {
          this.$emit('onSelect', []);
          this.fillSelection();
        }
      }
    }

  }
</script>


<style>
  .lms-b-table {

  }

  .lms-b-table .Button {
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// BaseTable.vue?e5e22294